import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) {
  // Fatal boot-time configuration error. Throwing here (rather than logging)
  // makes the misconfiguration surface immediately and keeps the browser
  // console clean of runtime application messages. The message intentionally
  // names only the ENVIRONMENT VARIABLE NAMES — never their values.
  throw new Error(
    "Supabase env vars missing — set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_PUBLISHABLE_KEY.",
  );
}

export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "quowada.auth",
  },
});
